import { Routes as AppRoutes } from "../routes";

const DETAILS_ID_KEY = "va_distributor_details_id";
const SIDEBAR_HOSPITAL_KEY = "va_sidebar_hospital_id";

/** Navigate to distributor details without exposing id in the URL. */
export function navigateToVaDistributorDetails(navigate, distributorId) {
  if (!distributorId) return;
  sessionStorage.setItem(DETAILS_ID_KEY, String(distributorId));
  navigate(AppRoutes.VaDistributorDetails.path, {
    state: { distributorId: String(distributorId) },
  });
}

/** Resolve distributor id from router state (with sessionStorage fallback on refresh). */
export function getVaDistributorDetailsId(location) {
  const fromState = location?.state?.distributorId;
  if (fromState) return String(fromState);
  const stored = sessionStorage.getItem(DETAILS_ID_KEY);
  return stored || null;
}

export function clearVaDistributorDetailsId() {
  sessionStorage.removeItem(DETAILS_ID_KEY);
}

/** Sidebar hospital filter — keep out of the URL. */
export function setVaSidebarHospitalId(hospitalId) {
  const id = String(hospitalId || "").trim();
  if (!id) {
    sessionStorage.removeItem(SIDEBAR_HOSPITAL_KEY);
    return;
  }
  sessionStorage.setItem(SIDEBAR_HOSPITAL_KEY, id);
}

export function getVaSidebarHospitalId() {
  return String(sessionStorage.getItem(SIDEBAR_HOSPITAL_KEY) || "").trim();
}

export function clearVaSidebarHospitalId() {
  sessionStorage.removeItem(SIDEBAR_HOSPITAL_KEY);
}
